var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.show
      ? _c("div", { staticClass: "posts-recap" }, [
          _c("div", { staticClass: "header" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("dash.posts.recap_title")) +
                  " \n        "
              ),
              _vm.totalPost > 1
                ? _c("span", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.countPost) +
                        " " +
                        _vm._s(_vm.$t("dash.posts.recap_title_count")) +
                        " " +
                        _vm._s(_vm.totalPost) +
                        "\n        "
                    ),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "actions" }, [
              _c(
                "div",
                { staticClass: "minimize", on: { click: _vm.minimize } },
                [_c("i", { staticClass: "material-icons" }, [_vm._v("remove")])]
              ),
              _c("div", { staticClass: "close", on: { click: _vm.close } }, [
                _c("i", { staticClass: "material-icons" }, [_vm._v("close")]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "content" }, [
            _c(
              "ul",
              { staticClass: "scrollable" },
              _vm._l(_vm.recap, function (item, index) {
                return _c(
                  "li",
                  { key: index, staticClass: "post", class: item.status },
                  [
                    ["all", "instagram"].includes(item.storification)
                      ? _c("ul", [
                          _c(
                            "li",
                            { staticClass: "status" },
                            [
                              _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text: `${
                                      item.status == "posting"
                                        ? _vm.$t("dash.posts.status.posting")
                                        : item.status === "scheduled"
                                        ? `${_vm.$t(
                                            "dash.posts.status.scheduled"
                                          )} - ${_vm.dateFormat(
                                            item.data.scheduled_date
                                          )}`
                                        : item.status === "error"
                                        ? `${_vm.$t(
                                            "dash.posts.status.error"
                                          )} - ${item.error}`
                                        : `${_vm.$t(
                                            "dash.posts.status.posted"
                                          )} - ${_vm.dateFormat(
                                            item.storification_date
                                          )}`
                                    }`,
                                    position: "top",
                                  },
                                },
                                [
                                  item.status == "posting"
                                    ? _c("img", {
                                        attrs: {
                                          src: require("../../../assets/img/status-waiting.gif"),
                                        },
                                      })
                                    : item.status == "scheduled"
                                    ? _c("img", {
                                        attrs: {
                                          src: require("../../../assets/img/status-scheduled.png"),
                                        },
                                      })
                                    : item.status == "error"
                                    ? _c("img", {
                                        attrs: {
                                          src: require("../../../assets/img/status-error.png"),
                                        },
                                      })
                                    : _c("img", {
                                        attrs: {
                                          src: require("../../../assets/img/status-posted.png"),
                                        },
                                      }),
                                  _vm._v("\n                 \n              "),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "li",
                            { staticClass: "page" },
                            [
                              _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text: _vm.getPageInfoByBot(item.bot).name,
                                    position: "top",
                                  },
                                },
                                [
                                  _c("page-image-avatar", {
                                    attrs: {
                                      page: _vm.getPageInfoByBot(item.bot),
                                    },
                                  }),
                                  _c("span", [_vm._v(" ")]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("li", { staticClass: "date" }, [
                            item.scheduled
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.dateFormat(item.storification_date)
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _c(
                            "li",
                            { staticClass: "type" },
                            [
                              _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text: _vm.$t("dash.posts.type.story"),
                                    position: "top",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v("smartphone")]
                                  ),
                                  _vm._v("\n                 \n              "),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("li", { staticClass: "content" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.data.title) +
                                "\n            "
                            ),
                          ]),
                          _c(
                            "li",
                            { staticClass: "action" },
                            [
                              item.status == "posted" &&
                              [
                                "facebook",
                                "twitter",
                                "linkedin",
                                "pinterest",
                                "instagram",
                              ].includes(_vm.getPageInfoByBot(item.bot).network)
                                ? _c(
                                    "Tooltip",
                                    {
                                      staticStyle: { visibility: "hidden" },
                                      attrs: {
                                        text:
                                          _vm.getPageInfoByBot(item.bot)
                                            .network === "facebook" &&
                                          item.data.typePost === "video"
                                            ? _vm.$t("dash.posts.view.warning")
                                            : _vm.$t("dash.posts.view"),
                                        position: "top",
                                      },
                                    },
                                    [
                                      _c("vs-button", {
                                        staticClass: "btnx",
                                        attrs: {
                                          type: "flat",
                                          icon: "visibility",
                                          disabled: _vm.disableShowPost,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            _vm.showPost(
                                              _vm.getPageInfoByBot(item.bot),
                                              item.pageEmbed.post_number_bis
                                                ? item.pageEmbed.post_number_bis
                                                : item.pageEmbed.post_number,
                                              item.data.videoReel
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(
                                        "\n                 \n              "
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              (item.status == "scheduled" &&
                                !(
                                  _vm.getPageInfoByBot(item.bot).isGroup &&
                                  _vm.getPageInfoByBot(item.bot).network ===
                                    "facebook"
                                )) ||
                              item.status == "error"
                                ? _c(
                                    "Tooltip",
                                    {
                                      staticStyle: { visibility: "hidden" },
                                      attrs: {
                                        text: _vm.$t("dash.button.edit.post"),
                                        position: "top",
                                      },
                                    },
                                    [
                                      _c("vs-button", {
                                        staticClass: "btnx",
                                        attrs: { type: "flat", icon: "edit" },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            _vm.editPost(
                                              _vm.getPageInfoByBot(item.bot).id,
                                              item.data.id || item.id,
                                              item.status
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(
                                        "\n                 \n              "
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              item.status == "posting"
                                ? _c("span", [_vm._v(" ")])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    ["facebook", "all"].includes(item.storification)
                      ? _c("ul", [
                          _c(
                            "li",
                            { staticClass: "status" },
                            [
                              _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text: `${
                                      item.status == "posting"
                                        ? _vm.$t("dash.posts.status.posting")
                                        : item.status === "scheduled"
                                        ? `${_vm.$t(
                                            "dash.posts.status.scheduled"
                                          )} - ${_vm.dateFormat(
                                            item.data.scheduled_date
                                          )}`
                                        : item.status === "error"
                                        ? `${_vm.$t(
                                            "dash.posts.status.error"
                                          )} - ${item.error}`
                                        : `${_vm.$t(
                                            "dash.posts.status.posted"
                                          )} - ${_vm.dateFormat(
                                            item.storification_date
                                          )}`
                                    }`,
                                    position: "top",
                                  },
                                },
                                [
                                  item.status == "posting"
                                    ? _c("img", {
                                        attrs: {
                                          src: require("../../../assets/img/status-waiting.gif"),
                                        },
                                      })
                                    : item.status == "scheduled"
                                    ? _c("img", {
                                        attrs: {
                                          src: require("../../../assets/img/status-scheduled.png"),
                                        },
                                      })
                                    : item.status == "error"
                                    ? _c("img", {
                                        attrs: {
                                          src: require("../../../assets/img/status-error.png"),
                                        },
                                      })
                                    : _c("img", {
                                        attrs: {
                                          src: require("../../../assets/img/status-posted.png"),
                                        },
                                      }),
                                  _vm._v("\n                 \n              "),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "li",
                            { staticClass: "page" },
                            [
                              _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text: _vm.fbAffectedBot[item.bot].name,
                                    position: "top",
                                  },
                                },
                                [
                                  _c("page-image-avatar", {
                                    attrs: {
                                      page: _vm.fbAffectedBot[item.bot],
                                    },
                                  }),
                                  _c("span", [_vm._v(" ")]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("li", { staticClass: "date" }, [
                            item.scheduled
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.dateFormat(item.storification_date)
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _c(
                            "li",
                            { staticClass: "type" },
                            [
                              _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text: _vm.$t("dash.posts.type.story"),
                                    position: "top",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v("smartphone")]
                                  ),
                                  _vm._v("\n                 \n              "),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("li", { staticClass: "content" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.data.title) +
                                "\n            "
                            ),
                          ]),
                          _c(
                            "li",
                            { staticClass: "action" },
                            [
                              item.status == "posted" &&
                              [
                                "facebook",
                                "twitter",
                                "linkedin",
                                "pinterest",
                                "instagram",
                              ].includes(_vm.getPageInfoByBot(item.bot).network)
                                ? _c(
                                    "Tooltip",
                                    {
                                      staticStyle: { visibility: "hidden" },
                                      attrs: {
                                        text:
                                          _vm.getPageInfoByBot(item.bot)
                                            .network === "facebook" &&
                                          item.data.typePost === "video"
                                            ? _vm.$t("dash.posts.view.warning")
                                            : _vm.$t("dash.posts.view"),
                                        position: "top",
                                      },
                                    },
                                    [
                                      _c("vs-button", {
                                        staticClass: "btnx",
                                        attrs: {
                                          type: "flat",
                                          icon: "visibility",
                                          disabled: _vm.disableShowPost,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            _vm.showPost(
                                              _vm.getPageInfoByBot(item.bot),
                                              item.pageEmbed.post_number_bis
                                                ? item.pageEmbed.post_number_bis
                                                : item.pageEmbed.post_number,
                                              item.data.videoReel
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(
                                        "\n                 \n              "
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              (item.status == "scheduled" &&
                                !(
                                  _vm.getPageInfoByBot(item.bot).isGroup &&
                                  _vm.getPageInfoByBot(item.bot).network ===
                                    "facebook"
                                )) ||
                              item.status == "error"
                                ? _c(
                                    "Tooltip",
                                    {
                                      staticStyle: { visibility: "hidden" },
                                      attrs: {
                                        text: _vm.$t("dash.button.edit.post"),
                                        position: "top",
                                      },
                                    },
                                    [
                                      _c("vs-button", {
                                        staticClass: "btnx",
                                        attrs: { type: "flat", icon: "edit" },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            _vm.editPost(
                                              _vm.getPageInfoByBot(item.bot).id,
                                              item.data.id || item.id,
                                              item.status
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(
                                        "\n                 \n              "
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              item.status == "posting"
                                ? _c("span", [_vm._v(" ")])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _c("ul", [
                      _c(
                        "li",
                        { staticClass: "status" },
                        [
                          item.status == "posting"
                            ? _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text: _vm.$t("dash.posts.status.posting"),
                                    position: "top",
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/status-waiting.gif"),
                                    },
                                  }),
                                  _vm._v("\n                 \n              "),
                                ]
                              )
                            : item.status == "posted" &&
                              _vm.getPageInfoByBot(item.bot).network ===
                                "facebook" &&
                              item.data.typePost === "video"
                            ? _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text: `${_vm.$t(
                                      "dash.posts.status.postedfb"
                                    )} - ${_vm.dateFormat(
                                      item.data.scheduled_date
                                    )}`,
                                    position: "top",
                                  },
                                },
                                [
                                  _c("img", {
                                    staticStyle: { width: "35px" },
                                    attrs: {
                                      src: require("../../../assets/img/status-postedfb.png"),
                                    },
                                  }),
                                  _vm._v("\n                 \n              "),
                                ]
                              )
                            : item.status == "posted"
                            ? _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text: `${_vm.$t(
                                      "dash.posts.status.posted"
                                    )} - ${_vm.dateFormat(
                                      item.data.scheduled_date
                                    )}`,
                                    position: "top",
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/status-posted.png"),
                                    },
                                  }),
                                  _vm._v("\n                 \n              "),
                                ]
                              )
                            : item.status == "scheduled"
                            ? _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text: `${_vm.$t(
                                      "dash.posts.status.scheduled"
                                    )} - ${_vm.dateFormat(
                                      item.data.scheduled_date
                                    )}`,
                                    position: "top",
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/status-scheduled.png"),
                                    },
                                  }),
                                  _vm._v("\n                 \n              "),
                                ]
                              )
                            : item.status == "error"
                            ? _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text: `${_vm.$t(
                                      "dash.posts.status.error"
                                    )} - ${item.error}`,
                                    position: "top",
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/status-error.png"),
                                    },
                                  }),
                                  _vm._v("\n                 \n              "),
                                ]
                              )
                            : item.status == "deleting"
                            ? _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text: _vm.$t("dash.posts.status.deleting"),
                                    position: "top",
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/status-waiting.gif"),
                                    },
                                  }),
                                  _vm._v("\n                 \n              "),
                                ]
                              )
                            : item.status == "deleted"
                            ? _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text: `${_vm.$t(
                                      "dash.posts.status.deleted"
                                    )} - ${_vm.dateFormat(
                                      item.data.deleted_date
                                    )}`,
                                    position: "top",
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/status-deleted.png"),
                                    },
                                  }),
                                  _vm._v("\n                 \n              "),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "li",
                        { staticClass: "page" },
                        [
                          _c(
                            "Tooltip",
                            {
                              attrs: {
                                text: item.fbAffected
                                  ? _vm.fbAffectedBot[item.bot].name
                                  : _vm.getPageInfoByBot(item.bot).name,
                                position: "top",
                              },
                            },
                            [
                              _c("page-image-avatar", {
                                attrs: {
                                  page: item.fbAffected
                                    ? _vm.fbAffectedBot[item.bot]
                                    : _vm.getPageInfoByBot(item.bot),
                                },
                              }),
                              _c("span", [_vm._v(" ")]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "li",
                        { staticClass: "date" },
                        [
                          item.scheduled
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.dateFormat(item.data.scheduled_date)
                                  )
                                ),
                              ])
                            : _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text: _vm.dateFormat(
                                      item.data.scheduled_date ||
                                        item.data.deleted_date
                                    ),
                                    position: "top",
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("dash.preview.date.now"))
                                    ),
                                  ]),
                                  _vm._v(" \n              "),
                                ]
                              ),
                        ],
                        1
                      ),
                      _c(
                        "li",
                        { staticClass: "type" },
                        [
                          item.data.typePost == "video"
                            ? _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text: _vm.$t("dash.posts.type.video"),
                                    position: "top",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v("videocam")]
                                  ),
                                  _vm._v("\n                 \n              "),
                                ]
                              )
                            : item.data.typePost == "image"
                            ? _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text: _vm.$t("dash.posts.type.image"),
                                    position: "top",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v("image")]
                                  ),
                                  _vm._v("\n                 \n              "),
                                ]
                              )
                            : item.data.typePost == "standard"
                            ? _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text: _vm.$t("dash.posts.type.snippet"),
                                    position: "top",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v("link")]
                                  ),
                                  _vm._v("\n                 \n              "),
                                ]
                              )
                            : item.data.typePost == "story"
                            ? _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text: _vm.$t("dash.posts.type.story"),
                                    position: "top",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v("smartphone")]
                                  ),
                                  _vm._v("\n                 \n              "),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("li", { staticClass: "content" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(item.data.title) +
                            "\n            "
                        ),
                      ]),
                      _c(
                        "li",
                        { staticClass: "action" },
                        [
                          item.status == "posted" &&
                          [
                            "facebook",
                            "twitter",
                            "linkedin",
                            "pinterest",
                            "instagram",
                            "bluesky",
                          ].includes(_vm.getPageInfoByBot(item.bot).network)
                            ? _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text:
                                      _vm.getPageInfoByBot(item.bot).network ===
                                        "facebook" &&
                                      item.data.typePost === "video"
                                        ? _vm.$t("dash.posts.view.warning")
                                        : _vm.$t("dash.posts.view"),
                                    position: "top",
                                  },
                                },
                                [
                                  _c("vs-button", {
                                    staticClass: "btnx",
                                    attrs: {
                                      type: "flat",
                                      icon: "visibility",
                                      disabled: _vm.disableShowPost,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        _vm.showPost(
                                          _vm.getPageInfoByBot(item.bot),
                                          item.pageEmbed.post_number_bis
                                            ? item.pageEmbed.post_number_bis
                                            : item.pageEmbed.post_number,
                                          item.data.videoReel
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v("\n                 \n              "),
                                ],
                                1
                              )
                            : _vm._e(),
                          (item.status == "scheduled" &&
                            !(
                              _vm.getPageInfoByBot(item.bot).isGroup &&
                              _vm.getPageInfoByBot(item.bot).network ===
                                "facebook"
                            )) ||
                          item.status == "error"
                            ? _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text: _vm.$t("dash.button.edit.post"),
                                    position: "top",
                                  },
                                },
                                [
                                  _c("vs-button", {
                                    staticClass: "btnx",
                                    attrs: { type: "flat", icon: "edit" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        _vm.editPost(
                                          _vm.getPageInfoByBot(item.bot).id,
                                          item.data.id || item.id,
                                          item.status
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v("\n                 \n              "),
                                ],
                                1
                              )
                            : _vm._e(),
                          item.status == "posting"
                            ? _c("span", [_vm._v(" ")])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
        ])
      : _c(
          "div",
          { staticClass: "posts-recap-minimize", on: { click: _vm.maximize } },
          [_vm._v("\n    " + _vm._s(_vm.recap.length) + "\n  ")]
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }